module.exports = __webpack_public_path__ + "img/PG4_1-1-952x400.df791bad.png";